export default __webpack_public_path__ + "static/media/typeform-dark.5ebdbe3a.svg";